import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from '../patient.module.scss'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { useNavigate, useLocation } from 'react-router-dom'

const Profile = (props) => {
  const { current, primary, name, DOB, phone_number, gender, city, owner } =
    props

  const navigate = useNavigate()
  const location = useLocation()
  const query = new URLSearchParams(location.search)

  // ** functions
  const navigateToProfile = (id, primary) => {
    if (primary) {
      navigate(`/patient?id=${id}`)
    } else {
      query.set('owner', id)
      navigate(`${location.pathname}?${query.toString()}`, {
        replace: true,
      })
    }
    // reload the page
    window.location.reload()
  }

  // ** Root Code
  return (
    <div>
      <div>
        {current && (
          <span className={styles.currentProfile + ' mr-2'}>
            Current Profile
          </span>
        )}
        {primary && (
          <span className={styles.primaryProfile}>Primary Profile</span>
        )}
      </div>
      <div className="d-flex">
        <div className={styles.profilesData}>
          <div>
            Name:{' '}
            <span className={styles.value}>
              {!current ? (
                <button
                  className={!current ? styles.link : ''}
                  onClick={() => {
                    primary
                      ? navigateToProfile(query.get('id'), true)
                      : navigateToProfile(owner, false)
                  }}
                >
                  {name || ''}
                </button>
              ) : (
                name || ''
              )}
            </span>
          </div>
          <div>
            DOB: <span className={styles.value}>{DOB || '-'}</span>
          </div>
          <div>
            Phone Number:{' '}
            <span className={styles.value}>{phone_number || '-'}</span>
          </div>
          <div>
            Gender: <span className={styles.value}>{gender || '-'}</span>
          </div>
          <div>
            City: <span className={styles.value}>{city || '-'}</span>
          </div>
        </div>
        {/* Can't delete Primary Profile  */}
        {!primary && (
          <div className="mx-4 mt-2">
            <button className={styles.deleteBtn + ' p-1'} disabled={true}>
              <FontAwesomeIcon icon={faTrashAlt} color="#df7467" />
            </button>
          </div>
        )}
      </div>
      <hr />
    </div>
  )
}

export default Profile
